import { useEffect } from 'react';

const SITE = 'Message for Children';
const TAGLINE = 'stories and colouring pages';

/**
 * Keeps <title> in step with the route and the chosen language. Without it
 * every page shares one title, which is what a browser tab, a bookmark and a
 * search result all show.
 *
 * Pass null on the home page: it keeps the descriptive title, because that is
 * the one that appears in search results for the site itself.
 */
export default function useDocumentTitle(pageTitle) {
    useEffect(() => {
        document.title = pageTitle
            ? `${pageTitle} — ${SITE}`
            : `${SITE} — ${TAGLINE}`;
    }, [pageTitle]);
}
